<template>
    <div class="privacy-policy">
        <section class="section-bg">
            <div class="px-4 lg:px-12 md:container md:mx-auto py-12 lg:py-32">
                <h1 class="page-title text-center text-primary">Privacy Policy</h1>
            </div>
        </section>
        <section>
            <div class="px-4 lg:px-12 md:container md:mx-auto py-12 lg:py-32">
                <div>
                    <p>Early Years Recruitment is a recruitment business which provides work-finding services to its clients and work-seekers.</p>
                    <p class="mt-4">The Company must process personal data (including sensitive personal data) so that it can provide these services – in doing so, the Company acts as a data controller.</p>
                    <p class="mt-4">You may give your personal details to the Company directly, such as on an application or registration form or via our website, or we may collect them from another source such as a jobs board. The Company must have a legal basis for processing your personal data. For the purposes of providing you with work-finding services and/or information relating to roles relevant to you we will only use your personal data in accordance with the terms of the following statement.</p>
                </div>
                <div class="mt-10">
                    <h4 class="text-2xl font-medium">1. Collection and use of personal data</h4>
                    <h3 class="text-lg font-medium mt-4">a. Purpose of processing and legal basis</h3>
                    <p class="mt-4 text-lg">The Company will collect your personal data (which may include sensitive personal data) and will process your personal data for the purposes of providing you with work-finding services. The legal bases we rely upon to offer these services to you are:</p>
                    <ul class="mt-4">
                        <li>Consent</li>
                        <li>Legitimate interest</li>
                        <li>Legal obligation</li>
                        <li>Contractual obligation</li>
                    </ul>
                    <h3 class="text-lg font-medium mt-6">b. Legitimate interest</h3>
                    <p class="mt-4 text-lg">Where the Company has relied on a legitimate interest to process your personal data our legitimate interests is/are as follows:</p>
                    <ul class="mt-4">
                        <li>To provide work finding services to individuals we need to process personal data to check the identity of our candidates, their right to work, their qualifications, references. It is in the legitimate interest of all parties involved the recruiter, the work seeker and the client – that the recruitment business can process personal data.</li>
                    </ul>
                    <h3 class="text-lg font-medium mt-6">c. Recipient/s of data</h3>
                    <p class="mt-4 text-lg">The Company will not process your data with any third party.</p>
                </div>
                <div class="mt-10">
                    <h4 class="text-2xl font-medium">2. Data retention</h4>
                    <p class="mt-4 text-lg">The Company will retain your personal data only for as long as is necessary. Different laws require us to keep different data for different periods of time.</p>
                    <p class="mt-4 text-lg">The Conduct of Employment Agencies and Employment Businesses Regulations 2003, require us to keep workseeker records for at least one year from (a) the date of their creation or (b) after the date on which we last provide you with work-finding services.</p>
                    <p class="mt-4 text-lg">We must also keep your payroll records, holiday pay, sick pay and pensions auto-enrolment records for as long as is legally required by HMRC and associated national minimum wage, social security and tax legislation. Where the Company has obtained your consent to process your personal/[and] sensitive personal data we will do so in line with our retention policy a copy of which is attached. Upon expiry of that period the Company will seek further consent from you. Where consent is not granted the Company will cease to process your personal data/[and] sensitive personal</p>
                </div>
                <div class="mt-10">
                    <h4 class="text-2xl font-medium">3. Your rights</h4>
                    <p class="mt-4 text-lg">Please be aware that you have the following data protection rights:</p>
                    <ul class="mt-4">
                        <li>The right to be informed about the personal data the Company processes on you;</li>
                        <li>The right of access to the personal data the Company processes on you;</li>
                        <li>The right to rectification of your personal data;</li>
                        <li>The right to erasure of your personal data in certain circumstances;</li>
                        <li>The right to restrict processing of your personal data;</li>
                        <li>The right to data portability in certain circumstances;</li>
                        <li>The right to object to the processing of your personal data that was based on a public or legitimate interest;</li>
                        <li>The right not to be subjected to automated decision making and profiling; and</li>
                        <li>The right to withdraw consent at any time.</li>
                    </ul>
                    <p class="mt-4 text-lg">Where you have consented to the Company processing your personal data you have the right to withdraw that consent at any time by contacting Early Years Recruitment by email <a href="mailto:admin@early-years.com" target="_blank">admin@early-years.com</a></p>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
useHead({
    title: 'Privacy Policy'
});
</script>

<style lang="scss" scoped>
.privacy-policy {
    ul {
        margin-bottom: 24px;
        li {
            line-height: 1.3;
            position: relative;
            padding-left: 24px;
            margin-bottom: 12px;
            &:before {
                position: absolute;
                content: '';
                top: 6px;
                left: 0;
                margin-right: 12px;
                border: 1px solid $brand-primary;
                height: 8px;
                width: 8px;
                border-radius: 5px;
            }
        }
    }
    a {
        color: $brand-primary;
        text-decoration: underline;
    }
}
</style>